/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaToggle from 'DesignSystem/TysiaToggle/index'
import TysiaToggleButton from 'DesignSystem/TysiaToggle/TysiaToggleButton/index'
import TysiaToggleText from 'DesignSystem/TysiaToggle/TysiaToggleText/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentCard/Treatment/Content/Actions/Content/Rename/Content/ChangeTreatmentPlan/Content",
  onChange
  
}) {
let renameChangeTreatmentPlanValueData = fromData.useDataValue({ viewPath,
context: 'rename',
path: 'change_treatment_plan',
})
let renameChangeTreatmentPlanChangeData = fromData.useDataChange({ viewPath,
context: 'rename',
path: 'change_treatment_plan',
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<TysiaToggle
  viewPath={`${viewPath}/TysiaToggle`}
 justifyContent="flex-start"
 data="rename.change_treatment_plan"
 value={renameChangeTreatmentPlanValueData}
 onChange={renameChangeTreatmentPlanChangeData}
 marginBottom={dtSpaceXs}
>
{childProps => (
<React.Fragment>
<TysiaToggleButton
{...childProps}
  viewPath={`${viewPath}/TysiaToggleButton`}
/>
<TysiaToggleText
{...childProps}
  viewPath={`${viewPath}/TysiaToggleText`}
 weight="medium"
 text="Change treatment plan"
/>
</React.Fragment>
)}
</TysiaToggle>
{children}
</React.Fragment>)
}